export default __webpack_public_path__ + "static/media/gradient.a647b562.png";